export default class Validation {

  static validationCharacters(value: string): string {
    value = value.replace(/[\.\\\/$&?`´"';#]/g, '');
	  return value;
  }

}
